
import { ADD_OR_REMOVE_DISCOUNT } from '../../checkoutConstType';

export const DiscountReducer=(state={},action)=> {
   
   switch (action.type) {
       case ADD_OR_REMOVE_DISCOUNT:
           return {
...state,discount:action.payload
           }
           
    
       default: return state;
   }
}